"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTag = void 0;
const react_1 = __importDefault(require("react"));
exports.GTag = (props) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("script", { async: true, src: `https://www.googletagmanager.com/gtag/js?id=${props.id}` }),
        react_1.default.createElement("script", { dangerouslySetInnerHTML: {
                __html: `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${props.id}');`,
            } })));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR3RhZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9HdGFnLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFBeUI7QUFFWixRQUFBLElBQUksR0FBbUMsQ0FBQyxLQUFZLEVBQUUsRUFBRTtJQUNuRSxPQUFPLENBQ0w7UUFDRSwwQ0FBUSxLQUFLLFFBQUMsR0FBRyxFQUFFLCtDQUErQyxLQUFLLENBQUMsRUFBRSxFQUFFLEdBQUc7UUFDL0UsMENBQVEsdUJBQXVCLEVBQUU7Z0JBQy9CLE1BQU0sRUFBRTs7O2tCQUdFLEtBQUssQ0FBQyxFQUFFLEtBQUs7YUFDeEIsR0FBRyxDQUNILENBQ0osQ0FBQTtBQUNILENBQUMsQ0FBQSJ9